<template lang="pug">

.appleWatch
  .appleWatch-intro.u-textCenter.u-mt-md
    .u-mb-xm
      img(src='https://cdn.baianat.com/static/resources/apple-watch/2.png', srcset='https://cdn.baianat.com/static/resources/apple-watch/2.png 1x, https://cdn.baianat.com/static/resources/apple-watch/2@2x.png 2x')
    AppTitle.u-mb-xs(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-8.is-tablet-10.is-center
      .column
        p.u-text-lg.u-mb-xs {{$t('mantraDesc')}}
    h4.u-mb-xm {{$t('ps')}}
    AppLink(to="https://baianat.com/files/file1fr2q01jr651cp0" class="button is-rounded is-wide is-secondary" :title="$t('download')") {{$t('download')}}
  section.u-mt-lg.u-textCenter
    img(src='https://cdn.baianat.com/static/resources/apple-watch/3.png', srcset='https://cdn.baianat.com/static/resources/apple-watch/3.png 1x, https://cdn.baianat.com/static/resources/apple-watch/3@2x.png 2x')


  section.u-mt-lg
    .grid.is-ultrawide-8.is-widescreen-9.is-desktop-10.is-center
      .column
        AppTitle.u-mb-xm(:title="$t('gui')" tag="h2")

        .grid.is-widescreen-8.is-desktop-10.is-tablet-11
          .column
            p {{$t('guiDesc')}}

  section.u-mt-lg
    .grid.is-ultrawide-8.is-widescreen-9.is-desktop-10.is-center
      .column
        .grid.is-tablet-6.is-middle
          .column
            .u-mb-sm
              h4.u-mb-xs {{$t('gradients')}}
              img(src='https://cdn.baianat.com/static/resources/apple-watch/12.png', srcset='https://cdn.baianat.com/static/resources/apple-watch/12.png 1x, https://cdn.baianat.com/static/resources/apple-watch/12@2x.png 2x')
            .u-mb-sm
              h4.u-mb-xs {{$t('colors')}}
              img(src='https://cdn.baianat.com/static/resources/apple-watch/13.png', srcset='https://cdn.baianat.com/static/resources/apple-watch/13.png 1x, https://cdn.baianat.com/static/resources/apple-watch/13@2x.png 2x')
            .u-mb-sm
              h4.u-mb-xs {{$t('typography')}}
              p {{$t('typographyDesc')}}
            .u-mb-sm
              h4.u-mb-xs {{$t('robotoLight')}}
              p abcdefghijklmnopqrstuvwxyz
              p ABCDEFGHIJKLMNOPQRSTUVWXYZ
              p 1234567890!@#$%^&*()_+
          .column
            img(src='https://cdn.baianat.com/static/resources/apple-watch/4.png', srcset='https://cdn.baianat.com/static/resources/apple-watch/4.png 1x, https://cdn.baianat.com/static/resources/apple-watch/4@2x.png 2x')
  section.u-mt-lg
    .grid.is-ultrawide-8.is-widescreen-9.is-desktop-10.is-center
      .column
        .grid.is-tablet-4.is-middle.u-textCenter
          .column.u-mb-sm
            img(src='https://cdn.baianat.com/static/resources/apple-watch/5.png', srcset='https://cdn.baianat.com/static/resources/apple-watch/5.png 1x, https://cdn.baianat.com/static/resources/apple-watch/5@2x.png 2x')
          .column.u-mb-sm
            img(src='https://cdn.baianat.com/static/resources/apple-watch/6.png', srcset='https://cdn.baianat.com/static/resources/apple-watch/6.png 1x, https://cdn.baianat.com/static/resources/apple-watch/6@2x.png 2x')
          .column.u-mb-sm
            img(src='https://cdn.baianat.com/static/resources/apple-watch/7.png', srcset='https://cdn.baianat.com/static/resources/apple-watch/7.png 1x, https://cdn.baianat.com/static/resources/apple-watch/7@2x.png 2x')
  section.u-mt-lg
    .grid.is-ultrawide-8.is-widescreen-9.is-desktop-10.is-center
      .column
        .grid.is-tablet-4.is-middle
          .column.u-mb-sm
            h4.u-mb-xs {{$t('screens')}}
            p {{$t('screensDesc')}}
          .column.u-mb-sm
            h4.u-mb-xs {{$t('wireIcons')}}
            p {{$t('wireIconsDesc')}}
          .column.u-mb-sm
            h4.u-mb-xs {{$t('elements')}}
            p {{$t('elementsDesc')}}

  section.appleWatch-blue.u-textCenter
    img.appleWatch-blue-img(src='https://cdn.baianat.com/static/resources/apple-watch/8.png', srcset='https://cdn.baianat.com/static/resources/apple-watch/8.png 1x, https://cdn.baianat.com/static/resources/apple-watch/8@2x.png 2x')
    AppTitle.u-mb-md(:title="$t('freeGui')" tag="h2")

    img.u-mb-lg(src='https://cdn.baianat.com/static/resources/apple-watch/9.png', srcset='https://cdn.baianat.com/static/resources/apple-watch/9.png 1x, https://cdn.baianat.com/static/resources/apple-watch/9@2x.png 2x')

  section.u-section-full.u-section-padding.appleWatch-white
    .grid.is-ultrawide-8.is-widescreen-9.is-desktop-10.is-center
      .column
        .grid.is-tablet-6.is-middle
          .column
            .u-mb-sm(v-for="item in $t('elegantItems')")
              h4.u-mb-xs {{item.title}}
              p {{item.desc}}

          .column
            img(src='https://cdn.baianat.com/static/resources/apple-watch/10.png', srcset='https://cdn.baianat.com/static/resources/apple-watch/10.png 1x, https://cdn.baianat.com/static/resources/apple-watch/10@2x.png 2x')


  section.u-mt-lg
    .grid.is-ultrawide-8.is-widescreen-9.is-desktop-10.is-center
      .column
        h2 {{$t('elements2')}}
        .grid.is-widescreen-7.is-desktop-9.is-tablet-10
          .column
            p {{$t('elements2Desc')}}

        .u-mt-lg
          img.u-img(src='https://cdn.baianat.com/static/resources/apple-watch/11.png', srcset='https://cdn.baianat.com/static/resources/apple-watch/11.png 1x, https://cdn.baianat.com/static/resources/apple-watch/11@2x.png 2x')

  section.u-section-full.u-section-padding.appleWatch-cta.u-textCenter.u-mt-lg
    AppTitle.u-mb-xs(:title="$t('cta')" tag="h2")


    .grid.is-widescreen-6.is-desktop-8.is-tablet-10.is-center
      .column
        p.u-text-lg.u-mb-xs {{$t('ctaDesc')}}
    AppLink(to="https://baianat.com/files/file1fr2q01jr651cp0" class="button is-rounded is-wide is-white" :title="$t('download')") {{$t('download')}}


</template>

<style lang="stylus">
$appleBg = #19141b
$appleMain = #5ac8fa

div.app.is-applewatch
  overflow: hidden
  background-color: $appleBg
  background: url('https://cdn.baianat.com/static/resources/apple-watch/1.jpg') no-repeat top center $appleBg

  .header.is-scroll
    background: $appleBg

  .footer
    border-top: none

.appleWatch
  position: relative
  z-index: 1

  &-intro
    h1
      color: $appleMain

  &-blue
    margin-left: -12vw
    margin-right: -12vw
    padding-right: 8vw
    padding-left: 8vw
    background-color: rgba(5, 125, 255, 0.66)
    margin-top: 400px

    &-img
      margin-top: -330px
      position: relative
      z-index: -1

      +mq($until: 'tablet')
        margin-top: -40%

  &-white
    background: $clWhite
    color: $clBlack
    padding-top: unitRes(100, 200)
    padding-bottom: unitRes(60, 140)

  &-cta
    background-color: #ff2a65
    padding: unitRes(100, 200)
    background-image: -moz-linear-gradient(90deg, rgb(255, 38, 118) 0%, rgb(255, 45, 85) 100%)
    background-image: -webkit-linear-gradient(90deg, rgb(255, 38, 118) 0%, rgb(255, 45, 85) 100%)
    background-image: -ms-linear-gradient(90deg, rgb(255, 38, 118) 0%, rgb(255, 45, 85) 100%)

  .u-heading-line
    padding-bottom: 0.09em
</style>

<script>
import { generateSeoMeta } from '~/utils/seo';

export default {
  scrollToTop: true,

  meta: {
    theme: 'is-applewatch   is-dark',
    logoText: '__NONE__'
  },
  head: generateSeoMeta({ title: 'pageTitle', description: 'pageDesc' }, { i18n: true })
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Apple Watch GUI",
    "pageDesc":"Free GUI for apple watch. Designed to provide 36 Flat elements that can be used easily for any apple watch applications.",
    "mantra":"GUI apple watch |redesign.",
    "mantraDesc":"36 Flat photoshop elements can be used easly in watch applications designand help you as analysis when you start to design the applications",
    "ps":"PSD  - Sketsh",
    "download":"Download",
    "gui":"Apple watch |GUI",
    "guiDesc":"Apple Watch display is only 1.5 inches which is a very small space to design for, so, we took this challenge to come up with a suitable interactive design for the Apple Watch display size and also for the human who is using it.",
    "gradients":"Gradients pallets",
    "colors":"Colors pallets",
    "typography":"Typography",
    "typographyDesc":"Since that it is a small display size, only 1.5 inches, we don’t have to use large or unsuitable fonts, the original Apple Watch are using SF Contact font, so we’ve used Roboto font in our design as it is very close to it and very suitable for these small devices.",
    "robotoLight":"Roboto Light",
    "screens":"36  Screen",
    "screensDesc":"36 different screens for different applications and usages.",
    "wireIcons":"41  Wire icons",
    "wireIconsDesc":"We have used wired icons as they are the most suitable.",
    "elements":"53  Elements",
    "elementsDesc":"Buttons, loader, icons… and more different GUI elements.",
    "freeGui":"Free GUI Apple watch |for designers and |developers",
    "elegantItems":{
      "1":{
        "title":"Elegant Look",
        "desc":"Simple and elegant look for a smartwatch that helps you fulfill your work."
      },
      "2":{
        "title":"Interactive Design",
        "desc":"Not only attractive, but also a interactive that keeps you away from getting bored."
      },
      "3":{
        "title":"UCD",
        "desc":"It's all about Human, this is our main rule when implementing any project."
      },
      "4":{
        "title":"Keep Close",
        "desc":"Apple Watch keep you close to  your work to fulfill it faster and smarter too."
      }
    },
    "elements2":"Elements",
    "element2sDesc":"Enjoy using Apple Watch GUI Free, with its multiple -usage colorful trendy elements.",
    "cta":"Free GUI Apple",
    "ctaDesc":"For all developers and designers enjoy now this redesign concept for Apple Watch GUI with all its icons, forms and elements.",
    "download":"Download"
  },
  "ar": {
    "pageTitle":"واجهة ساعة أبل",
    "pageDesc":"واجهة المستخدم الرسومية مجانية لساعة أبل تم تصميمها لتزويد 36 عنصر مسطح فوتوشوب يمكن استخدامه بسهولة لأي تطبيقات ساعة أبل.",
    "mantra":"إعادة تصميم واجهة |المستخدم الرسومية الخاصة |بساعة أبل",
    "mantraDesc":"36 عنصر فوتوشوب مسطح يمكن استخدامه بسهولة في تطبيقات الساعة ومساعدتك في التحليل عند بدء تصميم التطبيقات.",
    "ps":"PSD  - Sketsh",
    "download":"تحميل",
    "gui":"واجهة الاستخدام الرسومية |لساعة أبل",
    "guiDesc":"شاشة عرض ساعة أبل هي 1.5 بوصة فقط، وهي مساحة صغيرة جدًا لتصميمها، لكننا تحدينا أنفسنا للتوصل إلى تصميم تفاعلي مناسب لحجم شاشة ساعة آبل وكذلك يتناسب مع المستخدمين.",
    "gradients":"تدرجات لوحات الألوان",
    "colors":"لوحات الألوان",
    "typography":"التايبوجرافي",
    "typographyDesc":"نظرًا لأن الشاشة حجمها صغير 1.5 بوصة فقط، ليس علينا استخدام خطوط كبيرة، تستخدم ساعة أبل الأصلية خط SF Contact، لذا استخدمنا خط Roboto في تصميمنا حيث إنه قريب جدًا ومناسب للأجهزة الصغيرة.",
    "robotoLight":"Roboto Light",
    "screens":"36 شاشة ",
    "screensDesc":"36 شاشات مختلفة لمختلف التطبيقات والاستخدامات.",
    "wireIcons":"41 أيقونة خطية",
    "wireIconsDesc":"استخدمنا الأيقونات الخطية لأنها هي الأكثر ملاءمة.",
    "elements":"53 عنصر",
    "elementsDesc":"الأزرار والأيقونات والمزيد من عناصر واجهة المستخدم الرسومية المختلفة.",
    "freeGui":"واجهة الاستخدام الرسومية |لساعة أبل مجانًا لكل من |المصممين والمطورين",
    "elegantItems":{
      "1":{
        "title":"مظهر أنيق",
        "desc":"بسيطة وأنيقة مع الوظائف والخيارات المطلوبة تساعدك على إنجاز عملك."
      },
      "2":{
        "title":"تصميم تفاعلي",
        "desc":"ليس فقط جذابة، وإنما تفاعلية لتبعدك عن أي ملل قد تشعر به."
      },
      "3":{
        "title":"UCD",
        "desc":"مصممة وفقًا لاحتياجات المستخدمين والنماذج التصورية الخاصة بهم وهذه هي قاعدتنا الأولي عند تصميم كل شيء."
      },
      "4":{
        "title":"كُن مميزًا",
        "desc":"تجعلك ساعة أبل قريب من عملك لإنجازه بشكل أسرع وأكثر ذكاءً."
      }
    },
    "elements2":"العناصر",
    "element2sDesc":"استمتع باستخدام واجهة الاستخدام الرسومية لساعة أبل المجانية مع عناصرها العصرية متعددة الألوان.",
    "cta":"واجهة الاستخدام الرسومية لساعة أبل المجانية",
    "ctaDesc":"الآن يمكن لجميع المطورين والمصممين الاستمتاع بما قمنا به من إعادة تصميم واجهة المستخدم الرسومية لساعة آبل مع جميع الرموز والنماذج والعناصر.",
    "download":"تحميل"
  }
}
</i18n>
